<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[{ name: 'Sports Lottery', to: { path: '/sports-lottery' } }]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Sports Lottery News</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="createHandler">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增文章</span>
      </button>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <SportsLotteryTable></SportsLotteryTable>
    </div>
    <!-- Sports Lottery PageTitle -->
    <div class="page-actions">
      <h2>Sports Lottery PageTitle</h2>
      <v-spacer></v-spacer>
      <button class="btn" @click="toEditPageTitle">
        <v-icon class="mr-2">edit</v-icon>
        <span>編輯</span>
      </button>
    </div>
    <div class="block">
      <!-- PageTitle -->
      <div class="form-item py-5 d-flex">
        <div class="w-94px mr-166px">
          <h4>PageTitle</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          Title Demo
        </div>
      </div>
      <!-- Background -->
      <div class="form-item py-5 d-flex">
        <div class="w-94px mr-166px">
          <h4>Background</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <div
            class="bg-cover bg-center"
            :style="{
              width: '480px',
              height: '76px',
              'background-image': 'url(https://dummyimage.com/480x76.jpg)',
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SportsLotteryTable from '@/views/B-7__SportsLottery/c/SportsLotteryTable.vue';

export default {
  components: {
    Breadscrumbs,
    SportsLotteryTable,
  },
  methods: {
    createHandler() {
      this.$router.push('/sports-lottery/create');
    },
    toEditPageTitle() {
      this.$router.push('/sports-lottery/edit-sports-lottery-page-title');
    },
  },
};
</script>

<style></style>
